var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { browserStorage } from '../browserStorage';
import { getDeviceInfo } from '../utils';
import { urlBase64ToUint8Array } from '../utils1';
export var NotificationRequestKey = {
    KEY: 'notification-request',
};
var NotificationRequest = /** @class */ (function () {
    function NotificationRequest() {
    }
    NotificationRequest.prototype.onCloseModal = function () {
        browserStorage.setItem(NotificationRequestKey.KEY, 1);
    };
    NotificationRequest.prototype.showModal = function () {
        try {
            if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
                return;
            }
            console.log('Notification.permission', Notification.permission);
            if (Notification.permission === 'default' && !browserStorage.getItem(NotificationRequestKey.KEY)) {
                return 1;
            }
        }
        catch (e) {
            console.log(e);
        }
    };
    NotificationRequest.prototype.isGranted = function () {
        try {
            return Notification.permission === 'granted';
        }
        catch (e) { }
    };
    NotificationRequest.prototype.askPermission = function () {
        return new Promise(function (resolve, reject) {
            var permissionResult = Notification.requestPermission(function (result) {
                resolve(result);
            });
            if (permissionResult) {
                permissionResult.then(resolve, reject);
            }
        }).then(function (permissionResult) {
            if (permissionResult !== 'granted') {
                throw new Error('Permission denied');
            }
        });
    };
    NotificationRequest.prototype.askPermissionHelper = function () {
        return __awaiter(this, void 0, void 0, function () {
            var registration_1, subscription, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, navigator.serviceWorker.register('/custom-service-worker.js')];
                    case 1:
                        registration_1 = _a.sent();
                        registration_1.update();
                        return [4 /*yield*/, notificationRequest.askPermission().then(function () {
                                var options = {
                                    userVisibleOnly: true,
                                    applicationServerKey: urlBase64ToUint8Array(process.env.REACT_APP_VAPID_PUBLIC_KEY),
                                };
                                return registration_1.pushManager.subscribe(options);
                            })];
                    case 2:
                        subscription = _a.sent();
                        subscription = JSON.parse(JSON.stringify(subscription));
                        return [2 /*return*/, __assign({ endpoint: subscription.endpoint, auth_token: subscription.keys.auth, p256dh_token: subscription.keys.p256dh }, getDeviceInfo())];
                    case 3:
                        err_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return NotificationRequest;
}());
export var notificationRequest = new NotificationRequest();
